import { render, staticRenderFns } from "./NoteModal.vue?vue&type=template&id=2792dc2a&scoped=true&"
import script from "./NoteModal.vue?vue&type=script&lang=js&"
export * from "./NoteModal.vue?vue&type=script&lang=js&"
import style0 from "./NoteModal.vue?vue&type=style&index=0&id=2792dc2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2792dc2a",
  null
  
)

export default component.exports